import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HaloCustomLoaderService {
  constructor() {}
}
export enum HaloCustomLoaderErrorType {
  APIFAILED = 'CUSTOM.LOADER.ERROR.MSG.APIFAILED',
  CHECKBACKLATER = 'CUSTOM.LOADER.ERROR.MSG.CHECKBACKLATER',
  REDIRECTCHECKOUTPAGE = 'CUSTOM.LOADER.ERROR.MSG.REDIRECTCHECKOUTPAGE'
}
export enum HaloCustomLoaderButtonLabelType{
  REDIRECT = 'CUSTOM.LOADER.BUTTON.LABEL.REDIRECT'
}
